// App.js
import React from "react";
import { RecoilRoot } from "recoil";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Router from "./router/router";
import LoginProcess from "./pages/login/loginProcess";
import "./App.css";
import { useScrollToTop } from "./hooks/scrollToTop";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const App = () => {
  useScrollToTop();

  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <div className="App">
          <Router />
          <ToastContainer
            className="toast"
            position="top-center"
            autoClose={2000}
            hideProgressBar={true}
          />
          <LoginProcess />
        </div>
      </RecoilRoot>
    </QueryClientProvider>
  );
};

export default App;
